import { connectedStore } from '../../store';
import actions from '../actions';

const setActivePage = (pageId) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.setActivePage(pageId, resolve, reject));
  });

export default setActivePage;
